import * as activestorage from "@rails/activestorage";

export const useDirectUpload = (onSuccess, onError) => {
  const uploadFile = (file) => {
    const directUploadDelegate = {
      directUploadWillCreateBlobWithXHR: (xhr) => {
        xhr.setRequestHeader("X-CSRF-Token", localStorage.getItem("csrf_token"));
      },
    };

    const directUpload = new activestorage.DirectUpload(
      file,
      "/rails/active_storage/direct_uploads",
      directUploadDelegate,
    );

    directUpload.create(async (error, blob) => {
      if (error) {
        onError(error);
      } else if (blob) {
        onSuccess(blob);
      }
    });
  };

  return { uploadFile };
};
